import {
  BottomGroupMolecule,
  PageContentAtom,
  PrimaryButtonAtom,
  ToolbarMolecule
} from '@justomx/atlas-components'

import LoaderAtom from 'components/atoms/Loader.atom'
import { StackAtom } from 'components/atoms/Stack.atom'
import { InstructionsMolecule } from 'components/molecule/Instructions.molecule'
import { ScannerMolecule } from 'components/molecule/Scanner.molecule'
import { InputDialogOrganism } from 'components/organisms/InputDialog.organism'
import { PalletCardOrganism } from 'components/organisms/PalletCard.organism'
import { TransferProgressCard } from 'components/organisms/TransferProgressCard.organism'
import { useTransferDetail } from './TransferDetail.hook'

const TransferDetailPage = () => {
  const {
    docNum,
    palletsData,
    atLeastOnePalletScanned,
    dialogRef,
    scannedPallets,
    loading,
    actions
  } = useTransferDetail()
  const totalPallets = Object.keys(palletsData).length

  return (
    <>
      {loading && <LoaderAtom>actualizando orden</LoaderAtom>}

      <ToolbarMolecule
        title={docNum}
        actionIcon="close"
        onAction={actions.onGoBack}
        secondaryActionIcon="ic_keyboard"
        onSecondaryAction={actions.openKeyboard}
      />

      <PageContentAtom style={{ paddingBottom: '75px' }}>
        <StackAtom $direction="column" $gap={24}>
          <TransferProgressCard
            docNum={docNum}
            palletsLabel={`${scannedPallets.length}/${totalPallets}`}
          />

          <InstructionsMolecule lines={['Escanea las tarimas que armarás.']} />

          <StackAtom $direction="column" $gap={16}>
            {Object.values(palletsData).map((palletInfo) => (
              <PalletCardOrganism key={palletInfo.container} {...palletInfo} />
            ))}
          </StackAtom>
        </StackAtom>

        <BottomGroupMolecule bgColor="#212121">
          <PrimaryButtonAtom
            type="button"
            onClick={actions.onContinue}
            disabled={!atLeastOnePalletScanned}
          >
            Continuar
          </PrimaryButtonAtom>
        </BottomGroupMolecule>
        <ScannerMolecule mode="hidden" onScan={actions.onScanPallet} />

        <InputDialogOrganism
          dialogRef={dialogRef}
          title="Tarima"
          textboxLabel="Escribe el LPN de la tarima"
          confirmLabel="Continuar"
          cancelLabel="Cancelar"
          confirmAction={actions.onScanPallet}
        />
      </PageContentAtom>
    </>
  )
}

export default TransferDetailPage
